import { useTranslation } from "react-i18next";
import Button from "src/components/Button";
import Card from "src/components/Card";
import usePost from "src/hooks/rest/usePost";

const EditBankAccount = () => {
	const { t } = useTranslation("forms", {
		keyPrefix: "edit-bank-account",
	});
	return (
		<Card title={t("title")}>
			<div className="flex flex-col gap-1 mb-4">
				<p>{t("description")}</p>
			</div>
			<EditBankAccountButton />
		</Card>
	);
};

const EditBankAccountButton = () => {
	const { t } = useTranslation("forms", {
		keyPrefix: "edit-bank-account",
	});
	const [createNewBankAccount, loading] = usePost(`/student/bank-accounts`);

	const onClick = () => {
		createNewBankAccount({}).then((res) => {
			let { verification_url } = res.data;
			window.location = verification_url;
		});
	};

	return (
		<Button small {...{ onClick, loading }} type="outlined">
			{t("button")}
		</Button>
	);
};

export default EditBankAccount;
